import { fastJoin } from "@Utils";
import { useState } from "react";

/**
 * Convert JSON data to CSV format.
 */
export const useJSONToCSV = <T extends object>() => {
    const [csvData, setCsvData] = useState<string>("");

    const parse = (data: T[]): string => {
        if (!Array.isArray(data)) {
            console.error("This is not a valid array."); // eslint-disable-line no-console
            return "";
        }

        if (data.length === 0) {
            console.warn("The array is empty."); // eslint-disable-line no-console
            return "";
        }

        const headers = Object.keys(data[0]);
        const csvDataArray = data.map((row) =>
            fastJoin(
                headers.map((header) => {
                    const cellValue = row[header];
                    return cellValue === null || cellValue === undefined ? "" : String(cellValue);
                }),
                ","
            )
        );

        const result = fastJoin([fastJoin(headers, ","), ...csvDataArray], "\n");
        setCsvData(result);
        return result;
    };

    return { csvData, parse };
};

